import { SubscriptionStatus } from '@dtx-company/inter-app/src/types/subService'
import { fireAnalyticsEvent } from '@dtx-company/inter-app/src/event-tracking/helpers/fireAnalyticsEvent'
import { subscriptionSyncEndpoint } from '@dtx-company/inter-app/src/api/subscription-service/subscriptionSyncEndpoint'
import { useAuthState } from '@dtx-company/inter-app/src/hooks/useAuthState'

export const useRefreshTokenAfterSubscriptionChange = (): {
  refreshTokenAfterSubscriptionChange: (subscriptionId?: string) => Promise<void>
} => {
  const auth = useAuthState()

  const refreshTokenAfterSubscriptionChange = async (subscriptionId?: string): Promise<void> => {
    if (auth.token && subscriptionId) {
      //v3 subscription upgrade happens async. Possible scenario: user upgrade with 3D security card ->
      // createSubscriptionV3 request -> subscription service send request to confirm action ->
      // confirmation request goes to stripe server and user's bank -> stripe returns success to the FE and send event to the BE about confirmed transaction
      // before we update the jwt token we must be sure that the BE finished up all processes
      const subscriptionStatus = await subscriptionSyncEndpoint({
        token: auth.token,
        subscriptionId: subscriptionId
      })
      if (subscriptionStatus !== SubscriptionStatus.SUBSCRIBED) {
        // Subscription status should always be SUBSCRIBED, log it if it is not
        fireAnalyticsEvent('subscription_status_not_succeeded', {
          subscriptionId: subscriptionId,
          subscriptionStatus: subscriptionStatus
        })
      }
      await auth.refreshJwt()
    } else {
      await auth.refreshJwt()
    }
  }

  return { refreshTokenAfterSubscriptionChange }
}
